import { connect } from 'react-redux';

import { selectIsLogged } from '../SecuritySelector';

const Authenticated = ({ isLogged, children }) => (isLogged ? children : null);

const mapStateToProps = (state) => ({
    isLogged: selectIsLogged(state),
});

export default connect(mapStateToProps)(Authenticated);
